import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Popconfirm,
  message,
  Spin,
  Card,
  Row,
  Col,
  Typography,
  Tooltip,
} from "antd";
import { DeleteOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import axios from "axios";
import Cookies from "js-cookie";
import { DiffChecker_URL } from "../../Components/Constant";
import DiffCheckerAuthenticate from "./DiffCheckerAuthenticate";
import DiffCheckerAuthorise from "./DiffCheckerAuthorise";

const { Title } = Typography;

const DiffConnections = () => {
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [authVisible, setAuthVisible] = useState(false); // Show OrgAuthenticate
  const [showUpdateToken, setShowUpdateToken] = useState(false); // Show UpdateTokenComponent
  const token = Cookies.get("tokenRes");

  // Check URL for 'code' on first render
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    if (code) {
      setShowUpdateToken(true);
    }
  }, []);

  // Fetch connections
  const fetchConnections = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${DiffChecker_URL}/query/connections`, {
        headers: { JWTToken: token },
      });
      setConnections(response.data);
    } catch (error) {
      message.error("Failed to fetch connections");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!authVisible && !showUpdateToken) {
      fetchConnections();
    }
  }, [authVisible, showUpdateToken]);

  // Delete connection
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${DiffChecker_URL}/delete/connection/${id}`, {
        headers: { JWTToken: token },
      });
      message.success("Connection deleted successfully");
      fetchConnections();
    } catch (error) {
      console.error("Delete error:", error);
      message.error("Failed to delete connection");
    }
  };

  // Table columns
  const columns = [
    { title: "Name", dataIndex: "Name", key: "Name" },
    { title: "Connection Type", dataIndex: "connectionType", key: "connectionType" },
    {
      title: "Instance URL",
      dataIndex: "instaceUrl", // make sure it matches API key
      key: "instaceUrl",
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Tooltip title="Delete">
          <Popconfirm
            title="Are you sure you want to delete this connection?"
            onConfirm={() => handleDelete(record.Id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined
              style={{ color: "red", marginRight: 0, fontSize: "16px", cursor: "pointer" }}
            />
          </Popconfirm>
        </Tooltip>
      ),
    },
  ];

  return (
    <Card>
      {showUpdateToken ? (
        <>
          <Row justify="end" style={{ marginBottom: 10 }}>
            <Button
              type="default"
              icon={<ArrowLeftOutlined />}
              onClick={() => setShowUpdateToken(false)}
            >
              Back
            </Button>
          </Row>
          <DiffCheckerAuthorise />
        </>
      ) : authVisible ? (
        <>
          <Row justify="end" style={{ marginBottom: 10 }}>
            <Button
              type="default"
              icon={<ArrowLeftOutlined />}
              onClick={() => setAuthVisible(false)}
            >
              Back
            </Button>
          </Row>
          <DiffCheckerAuthenticate />
        </>
      ) : (
        <>
          <Row justify="space-between" align="middle" style={{ marginBottom: 5 }}>
            <Col>
              <Title level={4} style={{ marginTop: 0 }}>
                My Connections
              </Title>
            </Col>
            <Col>
              <Button type="primary" onClick={() => setAuthVisible(true)}>
                Authenticate
              </Button>
            </Col>
          </Row>

          {loading ? (
            <Spin style={{ marginTop: 50 }} />
          ) : (
            <Table
              dataSource={connections}
              columns={columns}
              rowKey="id"
              pagination={{ pageSize: 10 }}
            />
          )}
        </>
      )}
    </Card>
  );
};

export default DiffConnections;
